<template>
<!-- 售后服务-详情 -->
    <div class="content">
        <div class="CustomerService">
            <img src="../assets/icon_touxiang@2x.png" alt="客服">
            <div>售后客服</div>
            <div>工作时间：周一到周五9:00-18:00</div>
            <div>(若有急事，可随时咨询)</div>
            <p>以"专业、专注、专心、专一"为服务理念,您的眼健康就是我们的最终目标;</p>
            <p>负责给客户讲解产品原理、使用方法演示及注意事项;</p>
            <p>负责受理、跟进、妥善处理顾客的咨询、查询问题解答、投诉;</p>
            <p>负责产品售后的运输、送货过程的客户跟踪服务;</p>
            <p>售后客户热线咨询: 010-82057855</p>
        </div>
        <router-link :to="{name: 'NoCustomerService'}">点击通知客服人员为您接入</router-link>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.content {
    padding: 28px;
    font-size: 34px;
    letter-spacing: 4px;
}
.CustomerService {
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.CustomerService img {
    display: block;
    margin: 0 auto;
    width: 150px;
}
.CustomerService div {
    text-align: center;
}
.CustomerService div:first-of-type {
    font-size: 40px;
    margin: 38px 0 30px;
}
.CustomerService div:last-of-type {
    margin-bottom: 60px;
}

.CustomerService p {
    line-height: 52px;
}
.content a {
    display: inline-block;
    width: 100%;
    text-align: center;
    height: 96px;
    background: #39495c;
    border-radius: 25px;
    line-height: 96px;
    color:#fff;
    margin-top: 210px;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerService.vue